import { Box } from '@mantine/core';
import { keyframes } from '../utils/keyframes';
import { forwardRef } from 'react';
import { useReducedMotion } from '../hooks';

export interface SwingProps {
  children: React.ReactNode;
  active?: boolean;
  duration?: number;
  angle?: number;
  infinite?: boolean;
  count?: number;
}

const Swing = forwardRef<HTMLDivElement, SwingProps>(
  (
    {
      children,
      active = true,
      duration = 1000,
      angle = 15,
      infinite = false,
      count = 1,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();

    if (reducedMotion || !active) {
      return <Box ref={ref}>{children}</Box>;
    }

    const iterationCount = infinite ? 'infinite' : count;

    const swingKeyframes = keyframes({
      '20%': { transform: `rotate3d(0, 0, 1, ${angle}deg)` },
      '40%': { transform: `rotate3d(0, 0, 1, -${angle * 0.67}deg)` },
      '60%': { transform: `rotate3d(0, 0, 1, ${angle * 0.33}deg)` },
      '80%': { transform: `rotate3d(0, 0, 1, -${angle * 0.33}deg)` },
      '100%': { transform: 'rotate3d(0, 0, 1, 0deg)' },
    });

    return (
      <Box
        ref={ref}
        style={{
          animation: `${swingKeyframes} ${duration}ms ease-in-out ${iterationCount}`,
          transformOrigin: 'top center',
          display: 'inline-block',
        }}
      >
        {children}
      </Box>
    );
  }
);

Swing.displayName = 'Swing';

export default Swing;
